// extracted by mini-css-extract-plugin
export var active = "_c9-7";
export var container = "_c9-0";
export var evenWidth = "_c9-4";
export var large = "_c9-5";
export var outlet = "_c9-8";
export var slide = "_c9-2";
export var small = "_c9-6";
export var tab = "_c9-3";
export var tabs = "_c9-1";